import { getCscLocationBasedDigitalExists, getDigitalRentalWoFirstService } from '../selectors/coreApi';
import { getRentalVehicleLocation } from '../selectors/rentalMission';

import { VEHICLE_OTHER_LOCATION } from '../enums';
import { isMissionInProgress } from './coreApi';
import { daysToMinutes, hoursToDays } from './date';

export const isCscLocationDigitalExit = state => {
  const allowsDigitalRental =
    getDigitalRentalWoFirstService(state) &&
    getCscLocationBasedDigitalExists(state).includes(VEHICLE_OTHER_LOCATION.OTHER) &&
    !isMissionInProgress(state);

  if (allowsDigitalRental) {
    return false;
  }

  const cscDigitalExit = getCscLocationBasedDigitalExists(state);
  const rentalLocation = getRentalVehicleLocation(state);

  return cscDigitalExit?.includes(rentalLocation);
};

/**
 * Calculates the maximum allowed rental duration in days.
 * This includes both the original rental duration and the remaining rental days allowed by the policy.
 *
 * @param {number} rentalDurationInHours - The original rental duration in hours.
 * @param {number} remainingRentalDays - The remaining rental days allowed by the policy.
 * @returns {number} The maximum allowed rental duration in days.
 */
export const getMaximumRentalDuration = (rentalDurationInHours, remainingRentalDays) => {
  if (!rentalDurationInHours || !remainingRentalDays) {
    return 0;
  }
  return hoursToDays(rentalDurationInHours) + remainingRentalDays;
};

/**
 * Checks if a rental extension duration is fully covered by the policy.
 *
 * @param {number} extensionDurationInMinutes - The desired extension duration in minutes.
 * @param {number} rentalDurationInHours - The original rental duration in hours.
 * @param {number} remainingRentalDays - The remaining rental days allowed by the policy.
 * @returns {boolean} True if the extension is fully covered, false otherwise.
 */
export const isRentalExtensionCovered = (extensionDurationInMinutes, rentalDurationInHours, remainingRentalDays) => {
  if (!extensionDurationInMinutes || !rentalDurationInHours || !remainingRentalDays) {
    return false;
  }

  const maximumRentalDuration = getMaximumRentalDuration(rentalDurationInHours, remainingRentalDays);
  return extensionDurationInMinutes <= daysToMinutes(maximumRentalDuration);
};
